import { MBMessageTypes } from "..";
import { trackExportDashboardToPDF } from "../../../../dashboard/analytics";
import { DASHBOARD_PDF_EXPORT_ROOT_ID } from "../../../../dashboard/constants";
import { saveDashboardPdf } from "../../../../visualizations/lib/save-dashboard-pdf";

/**
 * Receive the export PDF request from the iframe
 * and trigger the export PDF functionality.
 */
export const defaultHandlers = {
  [MBMessageTypes.requestExportPDF]: async (payload: {
    dashboardId: string;
    dashboardName: string;
  }) => {
    const cardNodeSelector = `#${DASHBOARD_PDF_EXPORT_ROOT_ID}`;
    await saveDashboardPdf(cardNodeSelector, payload.dashboardName).then(() => {
      trackExportDashboardToPDF(payload.dashboardId);
    });
  },
};
